<template>
  <div v-if="authors && abstract">
    <div class="row mt-3">
      <div class="col mx-auto" v-if="!inAction">
        <div class="alert alert-primary text-center h4">
          Click here to submit your confirmation:
          <div class="row mt-2">
            <div class="col">
              <button class="btn mx-auto my-auto btn-success d-flex" v-on:click="saveAndNext()">
                <icon :icon="['fal', 'save']" class="fa-2x"/>&nbsp;<span class="h4 my-auto">&nbsp;{{
                  wording[0].buttons.submit
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col d-flex text-primary font font-weight-bolder text-center" v-else>
        <Loader></Loader>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col">
        <div class="alert alert-primary group-title mb-0">
          {{ wording[abstract.setting_submission_id].confirm.header_abstract }}
        </div>
      </div>
    </div>
    <div class="row previewRow">
      <div class="col col-3 previewKey font-weight-bold">
        {{wording[abstract.setting_submission_id].confirm.abstract_title}}:
      </div>
      <div class="col col-md-8">{{abstract.title}}</div>
    </div>
    <div class="row previewRow">
      <div class="col col-3 previewKey font-weight-bold">
        {{ wording[abstract.setting_submission_id].confirm.abstract_reference }}:
      </div>
      <div class="col col-md-8">{{ abstract.reference_number }}</div>
    </div>
    <div class="row previewRow" v-if="abstract.selection_result">
      <div class="col col-3 previewKey font-weight-bold">
        {{wording[abstract.setting_submission_id].confirm.abstract_type}}:
      </div>
      <div class="col col-md-8">{{abstract.selection_result}}</div>
    </div>
    <div class="row previewRow">
      <div class="col-3 previewKey font-weight-bold">
        {{ _[abstract.setting_submission_id].submit.titel_authors }}:
      </div>
      <div class="col">
        <author-preview/>
      </div>
    </div>
    <!--    SESSION INFORMATION-->
    <div class="row mt-3 mb-3" v-if="confirmationDetails && confirmationDetails.length > 0">
      <div class="col">
        <div class="alert alert-primary group-title mb-0">
          {{ wording[abstract.setting_submission_id].confirm.header_sessions }}
        </div>
      </div>
    </div>
    <div v-for="(confirmationItem, confirmationIndex) in confirmationDetails"
         v-if="confirmationDetails && confirmationDetails.length > 0">
      <div class="row previewRow">
        <div class="col col-3 previewKey font-weight-bold">
          {{ wording[abstract.setting_submission_id].confirm.session_name }}:
        </div>
        <div class="col col-md-8">{{ confirmationItem.name }}</div>
      </div>
      <div class="row previewRow">
        <div class="col col-3 previewKey font-weight-bold">
          {{ wording[abstract.setting_submission_id].confirm.session_date }}:
        </div>
        <div class="col col-md-8">{{ confirmationItem.date }} {{ confirmationItem.time }}</div>
      </div>
      <hr v-if="confirmationIndex+1 < confirmationDetails.length">
    </div>
    <!--CONF DECISION-->
    <div class="row mt-3 mb-3">
      <div class="col">
        <div class="alert alert-primary group-title mb-0">
          {{ wording[abstract.setting_submission_id].confirm.header_confirmation_decision }}
        </div>
      </div>
    </div>
    <div class="row" v-if="errors.content__confirm_status">
      <div class="col">
        <div class="alert alert-danger">
          <ul>
            <li>{{ errors.content__confirm_status[0] }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="list-group">
          <button type="button" class="list-group-item list-group-item-action"
                  v-on:click="$set(abstract, 'content__confirm_status', 'confirmed')"
                  v-bind:class="{'active': (abstract.content__confirm_status === 'confirmed')}" v-if="abstract.selection_result !== 'Oral Poster'">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fal', 'check-circle']" class="my-auto fa-2x"
                      v-if="abstract.content__confirm_status === 'confirmed'"/>
                <icon :icon="['fal', 'circle']" class="my-auto fa-2x" v-else/>
              </div>
              <div class="col">
                <div class="font-weight-bold">{{ wording[abstract.setting_submission_id].confirm.confirm_title }}</div>
                <div>
                  <Speaker :submission_id="abstract.setting_submission_id" area="confirm" textkey="confirm_text"/>
                  <strong v-if="getPresenter.length > 0">{{ getPresenter[0].firstname }} {{
                      getPresenter[0].lastname
                    }}</strong>
                </div>
              </div>
            </div>
          </button>
          <button type="button" class="list-group-item list-group-item-action"
                  v-on:click="$set(abstract, 'content__confirm_status', 'Oral Poster')"
                  v-bind:class="{'active': (abstract.content__confirm_status === 'Oral Poster' || (abstract.selection_result === 'Oral Poster' && abstract.content__confirm_status === 'confirmed'))}"
                  v-if="abstract.selection_result === wording[abstract.setting_submission_id].confirm.upgrade_result || abstract.selection_result === 'Oral Poster'">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fal', 'check-circle']" class="my-auto fa-2x"
                      v-if="abstract.content__confirm_status === 'Oral Poster'  || (abstract.selection_result === 'Oral Poster' && abstract.content__confirm_status === 'confirmed')"/>
                <icon :icon="['fal', 'circle']" class="my-auto fa-2x" v-else/>
              </div>
              <div class="col">
                <div class="font-weight-bold">{{ wording[abstract.setting_submission_id].confirm.upgrade_title }}</div>
                <div>
                  <Speaker :submission_id="abstract.setting_submission_id" area="confirm" textkey="upgrade_text"/>
                </div>
              </div>
            </div>
          </button>
          <button type="button" class="list-group-item list-group-item-action"
                  v-on:click="$set(abstract, 'content__confirm_status', 'withdraw')"
                  v-bind:class="{'active': (abstract.content__confirm_status === 'withdraw')}">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fal', 'check-circle']" class="my-auto fa-2x"
                      v-if="abstract.content__confirm_status === 'withdraw'"/>
                <icon :icon="['fal', 'circle']" class="my-auto fa-2x" v-else/>
              </div>
              <div class="col">
                <div class="font-weight-bold">{{ wording[abstract.setting_submission_id].confirm.withdraw_title }}</div>
                <div>
                  <Speaker :submission_id="abstract.setting_submission_id" area="confirm" textkey="withdraw_text"/>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <!--    Autoren-->
    <div>
      <div class="row mt-3">
        <div class="col">
          <div class="alert alert-primary group-title mb-0">
            {{ wording[abstract.setting_submission_id].submit.titel_authors }}
          </div>
        </div>
      </div>
      <Overview @ruleXCheckDone="ruleXCheckDone"></Overview>
    </div>
    <!--    Fragebogen-->
    <entitegenerator :entities="entities" :values="abstract"
                     :system="{main: 'submission', action: 'create'}"
                     :error="errors"
                     language="en"
                     :models="{}"
                     mode="formular"></entitegenerator>
    <div class="row mt-3">
      <div class="col mx-auto" v-if="!inAction">
        <div class="alert alert-primary text-center h4">
          Click here to submit your confirmation:
          <div class="row mt-2">
            <div class="col">
              <button class="btn mx-auto my-auto btn-success d-flex" v-on:click="saveAndNext()">
                <icon :icon="['fal', 'save']" class="fa-2x"/>&nbsp;<span class="h4 my-auto">&nbsp;{{
                  wording[0].buttons.submit
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col d-flex text-primary font font-weight-bolder text-center" v-else>
        <Loader></Loader>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from "vuex";
import AuthorPreview from "../author/AuthorPreview";
import Overview from "../author/Overview";
import entitegenerator from "entite-generator";

export default {
  name: "Confirm",
  components: {Overview, AuthorPreview, entitegenerator},
  created() {
    this.getDetailsDetails();
    this.$set(this.mode, 'confirm', true);
    this.processing.preschange = false;
  },
  data() {
    return {
      errors: [],
      noSaveNext: null,
      initial_abstract: {},
      confirmationDetails: [],
      switchConfirmToPresenterChange: false,
      alreadyXChecked: false,
      inAction: false
    };
  },
  computed: {
    ...mapState([
      'status', 'wording', "cache", "abstract", "processing", "authors", "authorvalidation", "settings", "mode"
    ]),
    ...mapGetters([
      'getFirstCurrentPage', 'getSettings', 'getConfirmEntities', "getPresenter"
    ]),
    entities: function () {
      return this.getConfirmEntities(Number(this.abstract.setting_submission_id));
    }
  },
  methods: {
    ...mapActions(['CONFIRM_ABSTRACT', 'VALIDATE_TARGET', "CONFIRMATION_DETAILS"]),
    async saveAndNext() {
      this.inAction = true;
      //Abstract validieren
      let isValid = false;
      let targetXHr = 'confirmation/' + this.abstract.setting_submission_id
      let data = {template: {}, target: targetXHr};
      data.template = this.abstract;
      await this.VALIDATE_TARGET(data).then((result) => {
        isValid = true;
        this.errors = [];
      }).catch((error) => {
        isValid = false;
        this.errors = error.response.data;
        this.$noty.error(this.wording[0].notify.save_not_success);
        this.$noty.error(this.wording[0].notify.validation_error);
        this.processing.dynamicdata = false;
      });
      if (isValid === false) {
        this.inAction = false;
        return;
      }
      //Autoren Validierung
      this.authorvalidation.errors = [];
      let author_error = false;
      let presenter = this.authors.filter(author => author.role_id === 2);
      if (presenter.length === 0) {
        this.authorvalidation.is_checked = true;
        this.authorvalidation.status = false;
        isValid = false;
      }
      if (isValid === false) {
        this.inAction = false;
        this.$noty.error("Your abstract does not have a presenter.");
        return;
      }
      this.authorvalidation.status = true;
      for (const author of this.authors) {
        this.authorvalidation.is_checked = true;
        if (!author.institute || author.institute.length === 0) {
          this.authorvalidation.is_checked = true;
          this.authorvalidation.status = false;
          isValid = false;
          this.authorvalidation.errors.push({
            'author_id': author.id,
            'error': this._[this.abstract.setting_submission_id].author_overview.non_exist_institute
          });
        }
        let target = this.abstract.setting_submission_id + '/';
        target += author.role_id === 2 ? 'presenter/author' : 'coauthor/author';
        let additionalKey = 'additional_content';
        let author_implode = {};
        Object.assign(author_implode, author);
        if (Object.keys(author_implode).includes(additionalKey)) {
          let additionals = author_implode[additionalKey];
          delete author_implode[additionalKey];
          for (let itemkey in additionals) {
            author_implode[additionalKey + '__' + itemkey] = additionals[itemkey];
          }
        }
        await this.VALIDATE_TARGET({
          template: author_implode,
          target: target
        }).then((result) => {
        }).catch((error) => {
          this.authorvalidation.errors.push({'author_id': author_implode.id, 'error': error.response.data});
          this.authorvalidation.is_checked = true;
          this.authorvalidation.status = false;
          isValid = false;
        })
      }
      if (isValid === false) {
        this.inAction = false;
        return;
      }
      if (this.settings.confirmation.xcheck && this.settings.confirmation.xcheck.presenter === true && this.abstract.content__confirm_status !== 'withdraw' && !this.alreadyXChecked && this.abstract.type_id === 1) {
        let ruleX = false;
        await this.VALIDATE_TARGET({
          template: this.ruleXTemplate(),
          target: 'xcheck/presenter'
        }).then((result) => {
          // this.processing.rulex = false;
          let ruleXValue = result.data;
          ruleX = ruleXValue >= this.settings.confirmation.xcheck.countGreaterThen;
        }).catch((error) => {
          // this.processing.rulex = false;
          ruleX = false;
        });
        if (ruleX) {
          this.$noty.error("Save was <strong>not</strong> successful.<br>This presenter has too many confirmed presentations (max " + this.settings.confirmation.xcheck.countGreaterThen + " confirmed presentations allowed).");
          this.inAction = false;
          return false;
        }
      }
      //Abstract updaten
      this.abstract.confirmed = true;
      if (this.abstract.content__confirm_status === 'Oral Poster') {
        this.abstract.content__confirm_status = 'confirmed';
        this.abstract.selection_result = 'Oral Poster';
        this.abstract.content__confirm_posterupgrade = true;
      }
      if (this.abstract.content__confirm_status === 'withdraw') {
        this.abstract.status_id = 9;
      }
      this.processing.dynamicdata = false;
      await this.CONFIRM_ABSTRACT(this.$route.params.id).then((result) => {
        this.$noty.success(this.wording[0].notify.save_success);
        this.processing.dynamicdata = false;
        this.inAction = false;
        this.$router.push('/home');
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
        this.processing.dynamicdata = false;
      });
      this.inAction = false;
    },
    ruleXTemplate() {
      let presenter = this.authors.find(author => author.role_id === 2);
      if (!presenter) return false;
      let template = {
        "firstname": presenter.firstname,
        "lastname": presenter.lastname,
        "email": presenter.email,
        "setting_submission_id": [this.abstract.setting_submission_id],
        "additionalWhere": [{'field': 'confirmed', 'operator': '=', 'search': true},{'field': 'abstract.type_id', 'operator': '=', 'search': 1},{'field': 'abstract.id', 'operator': '!=', 'search': this.abstract.id}]
      };
      return template;
    },
    changePresenter() {
      if (this.abstract.content__confirm_status === 'confirmed') {
        this.switchConfirmToPresenterChange = true;
      }
      this.$set(this.abstract, 'content__confirm_status', 'presenterchange');
    },
    ruleXCheckDone() {
      this.alreadyXChecked = true;
    },
    async getDetailsDetails() {
      this.CONFIRMATION_DETAILS(this.$route.params.id).then((result) => {
        this.confirmationDetails = result.data;
      }).catch((error) => {
        this.confirmationDetails = [];
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.abstract.content__confirm_status === 'withdraw') {
      next()
    } else {
      let presenter = this.authors.filter(author => author.role_id === 2);
      if (presenter.length === 0) {
        this.authorvalidation.is_checked = true;
        this.authorvalidation.status = false;
        this.$noty.error("Your abstract does not have a presenter.");
      } else {
        next()
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.bottom-row {
  border-width: 5px !important;
  font-size: 1.25rem;
}
</style>
